import { __makeTemplateObject, __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import styled from 'styled-components';
import { Text, themeGet } from '@primer/react';

var StyledComponent = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* Font */\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen,\n    Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: ", "; // Default is normal\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n  cursor: ", ";\n  text-align: ", ";\n  text-decoration: ", ";\n\n  /* Margin */\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n\n  /* Padding */\n  padding: ", ";\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n\n  /* Color */\n  color: ", ";\n"], ["\n  /* Font */\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen,\n    Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-style: ", "; // Default is normal\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n  cursor: ", ";\n  text-align: ", ";\n  text-decoration: ", ";\n\n  /* Margin */\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n\n  /* Padding */\n  padding: ", ";\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n\n  /* Color */\n  color: ", ";\n"])), function (props) {
  return (props === null || props === void 0 ? void 0 : props.fontStyle) || "normal";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.fontSize) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.fontWeight) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.lineHeight) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.letterSpacing) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.cursor) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.textAlign) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.textDecoration) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.margin) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.marginTop) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.marginRight) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.marginBottom) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.marginLeft) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.padding) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.paddingTop) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.paddingRight) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.paddingBottom) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.paddingLeft) || "";
}, function (props) {
  return (props === null || props === void 0 ? void 0 : props.color) || themeGet("colors.fg.default");
});
var getStyledProps = function getStyledProps(variant, fontSize, as) {
  if (variant) {
    if (!as) {
      as = "span";
    }
    switch (variant) {
      case LTText.TextVariant.HEADER_BOLD:
        return {
          as: as,
          fontSize: "16px",
          lineHeight: "24px",
          fontWeight: "600"
        };
      case LTText.TextVariant.SUBHEADER_REGULAR:
        return {
          as: as,
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "400",
          letterSpacing: "-0.15px"
        };
      case LTText.TextVariant.SUBHEADER_BOLD:
        return {
          as: as,
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "600",
          letterSpacing: "-0.15px"
        };
      case LTText.TextVariant.SMALL_REGULAR:
        return {
          as: as,
          fontSize: "12px",
          lineHeight: "18px",
          fontWeight: "400"
        };
      case LTText.TextVariant.SMALL_BOLD:
        return {
          as: as,
          fontSize: "12px",
          lineHeight: "18px",
          fontWeight: "600"
        };
      default:
        // Default will be regular
        return {
          as: as,
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "400",
          letterSpacing: "-0.15px"
        };
    }
  } else {
    switch (fontSize) {
      case LTText.FontSize.FONT_32:
        return {
          as: as || "h1",
          lineHeight: "48px",
          letterSpacing: "0.4px"
        };
      case LTText.FontSize.FONT_24:
        return {
          as: as || "h2",
          lineHeight: "36px",
          letterSpacing: "0.3px"
        };
      case LTText.FontSize.FONT_20:
        return {
          as: as || "h3",
          lineHeight: "30px",
          letterSpacing: "0.3px"
        };
      case LTText.FontSize.FONT_16:
        return {
          as: as || "h4",
          lineHeight: "24px",
          letterSpacing: "0px"
        };
      case LTText.FontSize.FONT_14:
        return {
          as: as || "h5",
          lineHeight: "20px",
          letterSpacing: "-0.15px"
        };
      case LTText.FontSize.FONT_12:
        return {
          as: as || "h6",
          lineHeight: "18px",
          letterSpacing: "0px"
        };
      default:
        return {
          as: as || "h5",
          lineHeight: "20px",
          letterSpacing: "-0.15px"
        };
      // Default will be regular
    }
  }
};

var LTText = function LTText(_a) {
  var as = _a.as,
    _b = _a.className,
    className = _b === void 0 ? "" : _b,
    children = _a.children,
    id = _a.id,
    _c = _a.style,
    style = _c === void 0 ? {} : _c,
    _d = _a.text,
    text = _d === void 0 ? "" : _d,
    variant = _a.variant,
    rest = __rest(_a, ["as", "className", "children", "id", "style", "text", "variant"]);
  var content = children || text;
  var styledProps = getStyledProps(variant, rest === null || rest === void 0 ? void 0 : rest.fontSize, as);
  return /*#__PURE__*/React.createElement(StyledComponent, __assign({}, styledProps, {
    className: className,
    id: id,
    style: style
  }, rest), content);
};
LTText.TextVariant = {
  HEADER_BOLD: "HEADER_BOLD",
  SUBHEADER_BOLD: "SUBHEADER_BOLD",
  SUBHEADER_REGULAR: "SUBHEADER_REGULAR",
  SMALL_BOLD: "SMALL_BOLD",
  SMALL_REGULAR: "SMALL_REGULAR"
};
LTText.FontSize = {
  FONT_32: "32px",
  FONT_24: "24px",
  FONT_20: "20px",
  FONT_16: "16px",
  FONT_14: "14px",
  FONT_12: "12px"
};
var templateObject_1;

export { LTText as default };
